import { AppButton, FigmaTypography } from "@libs/zapi-ui/custom";
import { useTranslation } from "react-i18next";
import { cn } from "../../../shared/lib/utils";
import type { TSettingsTab } from "./SettingsPage";

export type TSettingsMenuSection = {
  key: string;
  label: string;
  items: { name: TSettingsTab; label: string; icon: React.ReactNode }[];
};

interface SidebarProps extends React.HTMLAttributes<HTMLElement> {
  activeTab: TSettingsTab;
  setActiveTab: (tab: TSettingsTab) => void;
  menuItems: TSettingsMenuSection[];
}

export function Sidebar({ className, activeTab, setActiveTab, menuItems }: SidebarProps) {
  const { t } = useTranslation("settings");

  return (
    <aside className={cn("w-[260px] border-r", className)}>
      <div className="space-y-4 py-[18px]">
        <div className="px-1">
          <FigmaTypography variant="heading-3" color="zinc900" className="pl-[14px]">
            {t("title")}
          </FigmaTypography>
          <div className="space-y-1">
            {menuItems.map((section) => (
              <div key={section.key}>
                <h3 className="mb-1 mt-4 px-4 text-[14px] font-medium text-muted-foreground">{section.label}</h3>
                <div className="space-y-1 flex flex-col items-start">
                  {section.items.map((item) => (
                    <AppButton
                      key={item.name}
                      onClick={() => setActiveTab(item.name)}
                      appearance={activeTab === item.name ? "contained" : "text"}
                      color="zinc150"
                      className="w-full justify-start"
                    >
                      {item.icon}
                      {item.label}
                    </AppButton>
                  ))}
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </aside>
  );
}
